module.exports = __webpack_public_path__ + "static/media/check.05459161.svg";